import React from 'react';

const Footer = () => {
  return (
    <footer className="dark-full-container" style={{
      backgroundColor: 'var(--bg-secondary)',
      borderTop: '1px solid var(--border-subtle)',
      paddingTop: '60px',
      paddingBottom: '60px'
    }}>
      <div className="dark-content-container">
        <div style={{
          textAlign: 'center',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          {/* Primary Tagline */}
          <div className="heading-2" style={{ 
            color: 'var(--brand-primary)', 
            marginBottom: '16px',
            fontStyle: 'italic'
          }}>
            QuByt AI — From Business Requirement to Secure Application
          </div>
          
          {/* Secondary Tagline */}
          <div className="body-large" style={{ 
            color: 'var(--text-primary)', 
            marginBottom: '32px',
            lineHeight: 1.6
          }}>
            Intelligent by design. Secure by default. Ready for business.
          </div>
          
          {/* Copyright */}
          <div className="body-small" style={{ color: 'var(--text-muted)' }}>
            © {new Date().getFullYear()} QuByt AI. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;